import { render, staticRenderFns } from "./CbrAvailabilityItem.vue?vue&type=template&id=27ee44b4&scoped=true&lang=pug"
import script from "./CbrAvailabilityItem.vue?vue&type=script&lang=js"
export * from "./CbrAvailabilityItem.vue?vue&type=script&lang=js"
import style0 from "./CbrAvailabilityItem.vue?vue&type=style&index=0&id=27ee44b4&prod&lang=scss&scoped=true"
import style1 from "./CbrAvailabilityItem.vue?vue&type=style&index=1&id=27ee44b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ee44b4",
  null
  
)

export default component.exports